interface CounterProps {
	count: number;
	unit: number;
}

export const Counter = ({ count, unit }: CounterProps) => {
	return (
		<div className="counter">
			<span>{count}</span>/ <span>{unit}</span>
		</div>
	);
};
